// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".form-group .control-label[data-v-061a8594]{font-weight:400}", "",{"version":3,"sources":["webpack://./resources/js/apps/event-landing-page/ui/registration-modal/CustomerStep.vue"],"names":[],"mappings":"AACA,4CACE,eAAF","sourcesContent":["\n.form-group .control-label {\n  font-weight: 400;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
